export enum EntityStatus {
	LegacyActive = 0,
	Active = 1,
	Archived = 2,
	PendingPayment = 3,
	Suspended = 99
}
